import PDCalcID from '../components/calc/profile-doors/CalcID.svelte';
import PDCalcIDEnamel from '../components/calc/profile-doors/CalcIDEnamel.svelte';
import PDCalcIDFramePanel from '../components/calc/profile-doors/CalcIDFramePanel.svelte';
import PDCalcIDGlassDoors from '../components/calc/profile-doors/CalcIDGlassDoors.svelte';
import PDCalcIDInfinity from '../components/calc/profile-doors/CalcIDInfinity.svelte';
import PDCalcIDInvisible from '../components/calc/profile-doors/CalcIDInvisible.svelte';
import PDCalcIDIntegrAL from '../components/calc/profile-doors/CalcIDIntegrAL.svelte';
import PDCalcIDPenal from '../components/calc/profile-doors/CalcIDPenal.svelte';
import PDCalcIDSystem from '../components/calc/profile-doors/CalcIDSystem.svelte';
import PDCalcIDTsargovye from '../components/calc/profile-doors/CalcIDTsargovye.svelte';
import PDCalcService from '../components/calc/profile-doors/CalcService.svelte';
import PDCalcFurnitura from '../components/calc/profile-doors/CalcFurnitura.svelte';
import PDCalcDelivery from '../components/calc/profile-doors/CalcDostavka.svelte';
import PDCSVParse from "../components/page/profile-doors/CSVParse.svelte";
import PartMaterialsPercents from '../components/parts/MaterialsPercents.svelte';
import CalcPriceSimple from "../components/parts/PriceSimple.svelte";

let list = [];
let page = [];
let logo = null;
let precision = null;

if (APP_TYPE === 'profile-doors') {
    logo = 'profildoors.png';
    precision = 1;

    list.push({
        title: 'Межкомнатные двери',
        calc: 'Межкомнатные',
        img: '',
        description: 'Межкомнатные двери.',
        link: 'internal-doors',
        component: PDCalcID,
    });
    
    // Царговые, серии U L X XN --сложные серии писать вперед
    ['U', 'L' , 'XN', 'X'].forEach((series) => {
        list.push({
            title: `Царговые (Серия ${series})`,
            calc: 'Межкомнатные',
            link: `internal-doors/tsargovye/${series}`,
            hide: true,
            component: PDCalcIDTsargovye,
            components: [
                CalcPriceSimple,
                PartMaterialsPercents,
            ],
            options: {series}
        });
    });
    
    // Эмалевые, серии PWB PA PM PW PD LA P --сложные серии писать вперед
    ['PA', 'PM', 'PWB', 'PW', 'PD', 'PE', 'P'].forEach((series) => {
        list.push({
            title: `Эмалевые (Серия ${series})`,
            calc: 'Межкомнатные',
            link: `internal-doors/enamel/${series}`,
            hide: true,
            component: PDCalcIDEnamel,
            components: [
                CalcPriceSimple,
                PartMaterialsPercents,
            ],
            options: {series}
        });
    });
    
    // Каркасно-щитовые, серии E Z LK SMK ZN M  --сложные серии писать вперед
    ['E', '0Z', 'Z', 'LK', 'SMK', 'ZN', 'M', 'LW', 'LE', 'LA', 'NE', 'NA', 'N'].forEach((series) => {
        list.push({
            title: `Каркасно-щитовые (Серия ${series})`,
            calc: 'Межкомнатные',
            link: `internal-doors/framepanel/${series}`,
            hide: true,
            component: PDCalcIDFramePanel,
            components: [
                CalcPriceSimple,
                PartMaterialsPercents,
            ],
            options: {series}
        });
    });
    
    // Стеклянные двери, серии AG AX AV AGK AGN AGP --сложные серии писать вперед
    ['AG', 'AX', 'AP', 'AV', 'AGK', 'AGN', 'AGP'].forEach((series) => {
        list.push({
            title: `Стеклянные двери (Серия ${series})`,
            calc: 'Межкомнатные',
            link: `internal-doors/glassdoor/${series}`,
            hide: true,
            component: PDCalcIDGlassDoors,
            components: [
                CalcPriceSimple,
                PartMaterialsPercents,
            ],
            options: {series}
        });
    });

    // Механизмы открывания, серии Magic DivaAir Folding
    ['Magic', 'DivaAir', 'Складная'].forEach((series) => {
        list.push({
            title: `Механизмы открывания (Серия ${series})`,
            calc: 'Межкомнатные',
            link: `internal-doors/system/${series}`,
            hide: true,
            component: PDCalcIDSystem,
            components: [
                CalcPriceSimple,
                PartMaterialsPercents,
            ],
            options: {series}
        });
    });

    // Механизмы открывания, серии IntegrAL
    list.push({
        title: `Механизмы открывания (Серия IntegrAL)`,
        calc: 'Межкомнатные',
        link: `internal-doors/system/IntegrAL`,
        hide: true,
        component: PDCalcIDIntegrAL,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
        options: {series: 'IntegrAL'}
    });

    // Скрытые двери, серии  Infinity
    list.push({
        title: `Скрытые двери (Серия Infinity)`,
        calc: 'Межкомнатные',
        link: `internal-doors/hidden/Infinity`,
        hide: true,
        component: PDCalcIDInfinity,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
        options: {series: 'Infinity'}
    });

    // Скрытые двери, серии  Invisible
    list.push({
        title: `Скрытые двери (Серия Invisible)`,
        calc: 'Межкомнатные',
        link: `internal-doors/hidden/Invisible`,
        hide: true,
        component: PDCalcIDInvisible,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
        options: {series: 'Invisible'}
    });

    // Пенал
    list.push({
        title: `Пенал и Перегородки`,
        calc: 'Межкомнатные',
        link: `internal-doors/system/Пенал`,
        hide: true,
        component: PDCalcIDPenal,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
    });


    list.push({
        title: 'Фурнитура',
        calc: 'Фурнитура',
        img: '',
        description: 'Фурнитура для дверей',
        link: 'furnitura',
        component: PDCalcFurnitura,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
    });

    list.push({
        title: 'Доставка',
        calc: 'Доставка',
        img: '',
        description: 'Доставка дверей до объекта',
        link: 'delivery',
        component: PDCalcDelivery,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
    });

    list.push({
        title: 'Услуги',
        calc: 'Услуги',
        img: '',
        description: 'Услуги по установке дверей',
        link: 'service',
        component: PDCalcService,
        components: [
            CalcPriceSimple,
            PartMaterialsPercents,
        ],
    });


    page.push({
        title: 'Парсер CSV',
        link: 'parse',
        hide: true,
        component: PDCSVParse,
        components: [],
        options: {},
    })
}

export {list, page, logo, precision};
